<template>
  <div class="home">
    <Navbar :is-active="6"></Navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <div class="nav-mob-resp">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>Menu QuickPay</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/Indicators/productos" class="tab">
            <div class="tab__icon">
              <i class="fab fa-product-hunt"></i>
            </div>
            <div class="tab__text">
              <p>Productos</p>
            </div>
          </router-link>
          <router-link to="/Indicators/customers" class="tab">
            <div class="tab__icon">
              <i class="fas fa-user-friends"></i>
            </div>
            <div class="tab__text">
              <p>Clientes</p>
            </div>
          </router-link>
          <router-link to="/Indicators/sales" class="tab">
            <div class="tab__icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </div>
            <div class="tab__text">
              <p>Ventas</p>
            </div>
          </router-link>
          <router-link to="/Indicators/B2C" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-shopping-cart"></i>
            </div>
            <div class="tab__text">
              <p>Clientes B2C</p>
            </div>
          </router-link>
        </div>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
            <open-arrow></open-arrow>
          <h2>Clientes B2C</h2>
        </div>
        <div>
          <label style="padding-right: 9%">Fecha desde</label>
          <label style="padding-right: 23%">Fecha hasta</label>
        </div>
        <div class="page__filters">
          <input
              v-model="desde"
              style="width: 13.5%"
              type="date"
              placeholder="Fecha desde"
          />
          <input
              v-model="hasta"
              style=" width: 13.5%"
              type="date"
              placeholder="Fecha hasta"
          />
          <div class="input">
            <input
                type="text"
                v-model="ruc_number"
                placeholder="Ruc"
            />
          </div>
          <button @click="search"  style="background: #ff3128; border: none; border-radius:1rem; padding: 0 1rem;">
            <span style="color:white; font-weight:bold;">Buscar</span>
          </button>
        </div>
        <div v-if="this.branchoffice">
          <div class="accountant">
            <div class="accountant_number">
              <h1 style="color: #44ba7d">{{ branchoffice.total_clientes }}</h1>
              <p>Total clientes B2B activas</p>
            </div>
            <div class="accountant_number">
              <h1 style="color: #000000">{{ (branchoffice.promedio_clientes) ? branchoffice.promedio_clientes : 0 }}</h1>
              <p>Promedio de ventas por cliente</p>
            </div>
            <div class="accountant_number">
              <h2 style=" color: #44ba7d">{{ (branchoffice.cliente_mas_ventas) ?  branchoffice.cliente_mas_ventas : 0}}</h2>
              <p>Cliente con más cantidad de ventas</p>
            </div>
            <div class="accountant_number">
              <h2 style=" color: #ff3128">{{ (branchoffice.cliente_menos_ventas) ? branchoffice.cliente_menos_ventas : 0 }}</h2>
              <p>Cliente con menos cantidad de ventas</p>
            </div>
          </div>

          <div class="report">
            <div class="simple_table">
              <div class="page__table">
                <div class="table-headers">
                  <p>Raking</p>
                  <p>Cliente B2B</p>
                  <p>Cantidad vendido</p>
                </div>
                <div class="table-body">
                  <div class="data" v-for="(branch, key) of branchoffice.ranking_clientes" :key="branch.id">
                    <div class="data">
                      <p>{{ key+1 }}</p>
                      <p>{{ branch.cliente }}</p>
                      <p>{{ (branch.ventas) ? branch.ventas : 0 }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: 26%; padding-top: 3%; padding-left: 2%;">
              <BarChart :header="header"  :body="body"/>
            </div>
          </div>
        </div>
          <p v-else class="indicador">{{mensaje}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/NavBar'
import OpenArrow from '@/components/OpenArrow.vue';
import HiddenArrow from '@/components/HiddenArrow.vue';
import BarChart from '@/components/BarChart'

export default {
  name: 'IndicatorsB2C',
  components: {
    Navbar,
    OpenArrow,
    HiddenArrow,
    BarChart
  },
  data() {
    return {
      branchoffice: null,
      desde: null,
      mensaje: 'Ingrese un rango de fechas',
      hasta: null,
      fecha: '',
      usuario: '',
      list: [],
      header: [],
      body: [],
    }
  },
  created() {
    this.usuario = localStorage.getItem('usuario');
    this.getDate();
  },
  mounted() {
    this.basicInfo()
    if (localStorage.getItem('token')) {
      this.getall()
    } else {
      this.$router.push('/login')
    }
  },
  methods: {
    changePage(url) {
      this.$router.push(url)
    },
    handleClick() {
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    search: function() {
      if(""){
        this.mensaje
      }else{
        clearTimeout(this.timeout);
        var self = this;
        this.timeout = setTimeout(function () {
          let paramSearch = {
            desde: self.desde,
            hasta: self.hasta,
            ruc_number: self.ruc_number
          }
          this.getall(paramSearch)
        }.bind(this), 500);
      }
    },
    getall(paramSearch = {}) {
      let data = {
        desde:  (paramSearch.desde) ? paramSearch.desde : null,
        hasta:  (paramSearch.hasta) ? paramSearch.hasta : null,
        ruc_number:  (paramSearch.ruc_number) ? paramSearch.ruc_number : null,
      }
      let result = axios.post('general/indicator/admin/bycompanies',data).then(res => {
        console.log(res.data.data);
        if(res.data.status  == 202){
          this.$swal({
            position: 'center',
            icon: 'error',
            title: res.data.message,
            showConfirmButton: true,
            timer: 2000
          })
        }else{
        this.branchoffice = res.data.data
        this.branchoffice.ranking_clientes.forEach(item =>{
          this.header.push(item.cliente)
          this.body.push(item.ventas)
        })
        }
      })
    },
    basicInfo() {
      this.usuario = localStorage.getItem('usuario')
      this.list = JSON.parse(localStorage.getItem('getListOfMenu'))
      this.getDate()
    },
    getDate() {
      let dias = [
        'Lunes',
        'Martes',
        'Miercoles',
        'Jueves',
        'Viernes',
        'Sabado',
        'Domingo'
      ]
      let meses = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre'
      ]

      let date = new Date()

      var fechaNum = date.getDate()
      var mes_name = date.getMonth()

      this.fecha =
          dias[date.getDay() - 1] +
          ' ' +
          this.zeroFill(fechaNum, 2) +
          ' de ' +
          meses[mes_name]
    },
    zeroFill(number, width) {
      width -= number.toString().length
      if (width > 0) {
        return (
            new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
        )
      }
      return number + ''
    },
    url(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
.body__sidebar.open{
  display: none;
}
.page__title{
  display: flex;
  gap: .5rem;
}
.page__title .floating-icon{
  right: -15px;
  top: 30px;
  color: #ff3128;
  font-size: 30px;
}
.page__title h2{
  margin-top: 6px;
}
/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 200px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul {
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: 0.3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
}
.home .navbar__right .profile {
  display: flex;
  width: 300px;
  height: 100%;
}

.home .navbar__right .profile__detail {
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;
}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}
.body {
  width: 100%;
  height: 600px;
  display: flex;
}
.body__sidebar,
.body__containt {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}
.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 30px;
  color: #ff3128;
  font-size: 30px;
}
.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;
}
.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}
.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}
.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}
.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}
.body__sidebar .tabs .tab__text p {
  margin: 0;
  font-weight: 600;
}
.body__containt {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
}
.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}
.body__containt .page__title h2 {
  font-weight: 600;
  color: #ff3128;
  font-size: 25px;
}
.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}
.body__containt .page__filters input,
select {
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  background: #fff;
  padding: 15px 20px;
  /* margin: 0 10px; */
}
.body__containt .page__buttons {
  padding-left: 30%;
  display: flex;
  justify-content: flex-end;
}
.body__containt .page__buttons .button {
  width: 250px;
  padding: 15px 20px;
  border-radius: 15px;
  font-size: 17px;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.body__containt .page__buttons .button:nth-child(1) {
  background: #ff3128;
}
.body__containt .page__buttons .button:nth-child(2) {
  background: #262626;
}
.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}
.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 3);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}
.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 3);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
.accountant {
  display: flex;
  justify-content: space-evenly;
  margin-top: 5%;
  text-align: center;
}
.accountant h1 {
  font-size: 80px;
}
.report {
  display: flex;
}
.simple_table {
  width: 40%;
}
.body__sidebar.open{
  display: none;
}
/* INICIO MOBILE*/
@media (max-width: 768px){
  .body__containt .page__title h2{
    font-size: 21px;
  }
  .body__containt .page__filters input{
    padding: 5px 20px;
    font-size: 16px;

  }

  .body__containt .page__filters input:first-child{
    width: 48.5% !important;
    font-size: 14px;
  }
  .body__containt .page__filters input:nth-child(2){
    width: 48.5% !important;
    font-size: 14px;
    margin-left: -11px;

  }
  .body__containt .page__filters .input input{
    width: 76.5% !important;
  }
  .body label:nth-child(2) {
    padding-right: 21% !important;
    margin-left: 61px;
  }
  .page__filters select{
    padding: 10px 19px;
  }
  .body label{
    margin-top: 2rem;
    margin-left: 18px;
    font-size: 13px;
  }
  .body p.clean_filter{
    margin-top: 7px;
    font-size: 14px;

  }
  .buttonExport{
    margin-top: -13px;
    width: 179px;
    padding: 9px 20px;
  }
  .body__containt .page__table{
    font-size: 11px;
  }
  .body__containt .page__table .table-headers{
    margin-top: 6px;
    width: 245%;
  }
  .body__containt .page__table .table-body{
    width: 245%;
  }
  /*ESTILO PARA SIDEBAR*/
  .body__containt .page__table .table-body{
    width: 245%;
  }
  .body__sidebar .title__text h2 {
    font-size: 18px;
  }
  .body__sidebar .title__text {
    margin: 0 10px;
    font-size: 16px;
  }
  .body__sidebar .title__icon{

    font-size: 16px;
    margin-left: 6px;
  }
  .body__sidebar .tabs .tab__icon svg{
    font-size: 15px;
    margin-right: 7px;}
  .body__sidebar .tabs .a{
    margin-left: -2px;
    margin-top: -1px;
  }
  .body__sidebar a svg{
    font-size: 22px;
  }
  .body__sidebar .tabs .tab__text p {

    margin-left: -8px;
  }
  /*BARRA LATERAL IZQUIERDA MOBILE*/
  .body__sidebar .tabs .tab__icon {
    color: white;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active svg {
    color: #ff3128;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active p {
    color: #ff3128;
    font-size: 20px;
  }
  .body__sidebar .tabs .tab__text p {
    margin-left: -8px;
    color: white;
    font-size: 18px;
  }
  .body__sidebar .tabs .tab:hover, .body__sidebar .tabs .tab.active{
    background: #262626;
    margin-bottom: -11px;
  }
  .body__containt .page__buttons .button{
    font-size: 13px;
    padding: 5px 20px;
    margin-top: -18px;
  }
  .body__containt .page__buttons {
    width: 105%;
  }
  .home .body .nav-mob-resp{
    position: absolute;
    background: #262626;
    height: 85vh;
    width: 25vh;
  }
  .body__sidebar .title {
    color: white;
  }
  .body__sidebar .floating-icon {
    position: absolute;
    right: -35px;
  }
  .body__sidebar .tabs .tab{
    margin-bottom: -7px;
  }

}
/*FIN DE MOBILE*/
</style>
